import { batch } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';

import { clearErrors, handleErrors } from './ErrorActions';
import { getAnswer } from '../api/help-topics';
import { ERROR_SOURCES } from '../constants/ErrorsConstants';
import { getJsonFreeStorageItem } from '../utils/storageUtils';

export const SET_CURRENT_QUESTION = 'SET_CURRENT_QUESTION';
export const SET_NEW_QUESTION_AND_ANSWERS = 'SET_NEW_QUESTION_AND_ANSWERS';
export const CLEAR_SEARCH_HISTORY = 'CLEAR_SEARCH_HISTORY';
export const SET_OPEN_HELP_TOPICS_MODAL = 'SET_OPEN_HELP_TOPICS_MODAL';

export const helpTopicsErrorFilter = ({ source }) => source !== ERROR_SOURCES.HELP_TOPICS;

export const setOpenHelpTopicsModal = (isOpen) => ({
  type: SET_OPEN_HELP_TOPICS_MODAL,
  isOpen,
});

export const setCurrentQuestion = (id) => ({
  type: SET_CURRENT_QUESTION,
  id,
});

export const setNewQuestionAndAnswers = (answer) => ({
  type: SET_NEW_QUESTION_AND_ANSWERS,
  answer,
});

export const clearSearchHistory = () => ({
  type: CLEAR_SEARCH_HISTORY,
});

export const clearHelpTopicsError = (dispatch) => {
  dispatch(clearErrors(helpTopicsErrorFilter));
};

export const getAnswers = (question) => async (dispatch) => {
  dispatch(clearHelpTopicsError);

  const data = await getAnswer(question);

  if (!data.hasError) {
    const questionAndAnswers = {
      answerInfo: data.ChatBotQuestionAndAnswer.Response,
      id: uuidv4(),
      question,
    };
    const jsonFree = getJsonFreeStorageItem('questionsAndAnswers') || [];
    localStorage.setItem('questionsAndAnswers', JSON.stringify([...jsonFree, questionAndAnswers]));

    batch(() => {
      dispatch(setNewQuestionAndAnswers([questionAndAnswers]));
      dispatch(setCurrentQuestion(questionAndAnswers.id));
    });
  } else {
    dispatch(setCurrentQuestion(null));
    dispatch(handleErrors(data.errors, { isTopBanner: true, source: ERROR_SOURCES.HELP_TOPICS }));
  }
};
